module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BH-e3e1ec8b60fa8b447903b386f34f1825.png";